import { Component, OnInit, ViewChild, AfterViewInit, Injector, OnDestroy } from '@angular/core';
import { NgbModal, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ThemePalette, MatPaginator } from '@angular/material';
import { OrderService } from '../services/order-service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'kt-offer-confirmation-form',
	templateUrl: './offer-confirmation-form.component.html',
	styleUrls: ['./offer-confirmation-form.component.scss']
})
export class OfferConfirmationFormComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}
	selectedPhoneNumber: string = "";

	preValue: string = "";
	onKeyupPhoneMask() {

		////////////////////////////////////////////



		let newVal = this.selectedPhoneNumber.replace(/\D/g, '');



		var start = this.selectedPhoneNumber.length;
		if (this.selectedPhoneNumber.length < this.preValue.length) {



			var lastChar: string = this.preValue.substr(this.preValue.length - 1);



			// this.message = 'Removing...'; //Just console
            /**while removing if we encounter ) character,
            then remove the last digit too.*/
			if (this.preValue.length < start) {
				if (lastChar == ")") {
					newVal = newVal.substr(0, newVal.length - 1);
				}
			}
			//if no number then flush
			if (newVal.length == 0) {
				newVal = "";
			} else if (newVal.length <= 3) {
                /**when removing, we change pattern match.
              "otherwise deleting of non-numeric characters is not recognized"*/
				newVal = newVal.replace(/^(\d{0,3})/, "($1");
			} else if (newVal.length <= 6) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
			} else {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
			}



		}
		else {




			// don't show braces for empty value
			if (newVal.length == 0) {
				newVal = "";
			}
			// don't show braces for empty groups at the end
			else if (newVal.length <= 3) {
				newVal = newVal.replace(/^(\d{0,3})/, "($1)");
			} else if (newVal.length <= 6) {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
			} else {
				newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, "($1) $2-$3");
			}

		}
		this.preValue = newVal;
		this.selectedPhoneNumber = newVal;
	}

	onChangePhoneNumber() {}
}
